function productPage(currentVariantId, currentPrice, isAvailable) {
    return {
        selectedImage: 0,
        quantity: 1,
        currentVariantId: currentVariantId,
        currentPrice: currentPrice,
        isAvailable: isAvailable,
        updateVariant(id, price, available) {
            this.currentVariantId = id;
            this.currentPrice = price;
            this.isAvailable = available;
        },
        addToCart() {
            const formData = {
                'items': [{
                    'id': this.currentVariantId,
                    'quantity': this.quantity
                }]
            };

            fetch(window.routes.cart_add_url + '.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    fetch(window.routes.cart_url + '.js')
                        .then(res => res.json())
                        .then(cart => {
                            window.dispatchEvent(new CustomEvent('cart-updated', {
                                detail: {
                                    count: cart.item_count,
                                    cart: cart
                                }
                            }));
                        });
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }
}

window.productPage = productPage;
